<div class="content">
    <app-header></app-header>
    <router-outlet></router-outlet>
    <app-footer *ngIf="!hideFooter"> </app-footer>
</div>